import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StatusCard from "../components/status-card/StatusCard";
import productCards from "../assets/JsonData/product-menu-card.json";
import Modal from "../components/modal/Modal";
import TextBox from "../components/textboox/TextBox";
import MenuButton from "../components/menu-button/MenuButton";
import { Box } from "@mui/material";
import ProductStepper from "./Product/product_entry";
import Shapes from "./Shapes/Shapes";

import { Link } from "react-router-dom";
import Origin from "./Origin/Origin";
import { fetchAllShapes } from "../redux/features/shapes.features";
import { fetchAllTitles } from "../redux/features/titles.features";

import { fetchAllOrigin } from "../redux/features/origin.features";
import ProductGrid from "./Product/ProductGrid";
import Titles from "./Titles/Titles";
import TitlesGrid from "./Titles/TitlesGrid";

const Products = () => {
  const themeReducer = useSelector((state) => state.ThemeReducer.mode);
  const [showModal, updateShowModal] = React.useState(false);
  const [showOrigin, updateOriginShowModal] = React.useState(false);
  const [showShapeModal, updateShapeShowModal] = React.useState(false);
  const [showPreciousModal, updatePreciousShowModal] = React.useState(false);
  const [showEditTiltModal, updateEditTiltShowModal] = React.useState(false);
  const [showViewTiltModal, updateViewTiltShowModal] = React.useState(false);

  const toggleModal = () => updateShowModal((state) => !state);
  const toggleShapeModal = () => updateShapeShowModal((state) => !state);
  const toggleOriginModal = () => updateOriginShowModal((state) => !state);
  const togglePreciousModal = () => updatePreciousShowModal((state) => !state);
  const toggleTitleEditModal = () => updateEditTiltShowModal((state) => !state);
  const toggleTitleViewModal = () => updateViewTiltShowModal((state) => !state);

  const dispatch = useDispatch();

  let shapesState = useSelector((state) => {
    return state.shapesReducer;
  });
  let titlesState = useSelector((state) => {
    return state.titlesReducer;
  });

  let originState = useSelector((state) => {
    return state.originReducer;
  });

  let { shapes } = shapesState;
  let { titles } = titlesState;

  let { origin } = originState;

  useEffect(() => {
    dispatch(fetchAllShapes());
    dispatch(fetchAllTitles());

    dispatch(fetchAllOrigin());
  }, [dispatch]);

  return (
    <div className="flex flex-col w-full">
      <h2 className="my-3 flex items-center text-white text-3xl font-extrabold">
        <i className="bx bx-package mx-2"></i>
        Item Management
      </h2>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-3">
              <MenuButton
                onClick={toggleShapeModal}
                icon={"bx bx-diamond"}
                count={shapes.length}
                title={"Gem Shapes"}
              ></MenuButton>
            </div>
            <div className="col-3">
              <MenuButton
                editOnclick={toggleTitleEditModal}
                viewOnclick={toggleTitleViewModal}
                onClick={togglePreciousModal}
                icon={"bx bx-category"}
                count={titles.length}
                title={"Gem Titles"}
              ></MenuButton>
            </div>

            <div className="col-3">
              <MenuButton
                onClick={toggleOriginModal}
                icon={"bx bx-map"}
                count={origin.length}
                title={"Gem Origin"}
              ></MenuButton>
            </div>
          </div>
        </div>

        <div className="my-5 col-12">
          <div className="card">
            <ProductGrid productModalPopUp={toggleModal} />
          </div>
        </div>
      </div>

      {/* Product add Modals  */}
      <Modal
        modal_title={"Create New Item"}
        canShow={showModal}
        updateModalState={toggleModal}
      >
        <Box>
          <ProductStepper onClose={toggleModal} />
        </Box>
      </Modal>
      {/* Shape add Modals  */}

      <Modal
        modal_title={"Manage Shapes"}
        canShow={showShapeModal}
        updateModalState={toggleShapeModal}
      >
        <Box>
          <Shapes />
        </Box>
      </Modal>

      {/* Precious add Modals  */}
      <Modal
        modal_title={"Create Titles"}
        canShow={showPreciousModal}
        updateModalState={togglePreciousModal}
      >
        <Box>
          <Titles openMod={false} />
        </Box>
      </Modal>
      <Modal
        modal_title={"Edit Titles"}
        canShow={showEditTiltModal}
        updateModalState={toggleTitleEditModal}
      >
        <Box>
          <Titles openMod={true} />
        </Box>
      </Modal>

      <Modal
        modal_title={"View Titles"}
        canShow={showViewTiltModal}
        updateModalState={toggleTitleViewModal}
      >
        <Box>
          <TitlesGrid />
        </Box>
      </Modal>

      {/* Origin add Modals  */}
      <Modal
        modal_title={"Manage Origin"}
        canShow={showOrigin}
        updateModalState={toggleOriginModal}
      >
        <Box>
          <Origin />
        </Box>
      </Modal>
    </div>
  );
};

export default Products;
